import { TabPanelOptions } from '../../constants';

export const title = {
  [TabPanelOptions.CREATED_LISTS]: 'Você ainda não criou nenhuma checklist.\n Que tal criar uma agora?',
  [TabPanelOptions.RECEIVED_LISTS]: 'Você ainda não recebeu nenhuma checklist',
  NO_FILTER_RESULTS: 'Nenhum resultado encontrado. Ajuste os filtros ou faça uma nova busca.',
};
